import styled from 'styled-components'
import { Button } from 'components/atoms'
import React from 'react'

export const HospitalLocations = styled.div`
  font-weight: bolder;
  padding-left: 15px;

  @media ${ (props) => props.theme.breakpoints.devices.max.sm } {
    padding-top: 10px;
    padding-left: 0;
  }

  .locations-title {
    font-weight: bolder;
  }

  .address-item {
    display: flex;
    flex-direction: row;
    color: ${ (props) => props.theme.colors['standard-schwarz'] };
    margin: 20px 0;
  }

  .alphanumeric {
    font-size: 19px;
    padding: 0 10px 0 0;
    height: 100%;
    font-weight: bolder;
  }
`

export const AddressLink = styled(({ tag, children, ...props }) =>
  React.createElement(tag, props, children)
)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  font-weight: lighter;
  text-decoration: none;
  width: 100%;

  > span {
    margin-bottom: 2px;
  }
`

export const LoadMoreButton = styled((props) => <Button { ...props } />)`
  margin: 19px auto 0;
`
